import React from "react";
import { graphql } from "gatsby";
import Layout from '../containers/layout'
import BlogPost from '../components/blog-post'

import SEO from '../components/seo';

// load infinitescroll now to to speed up lazy load
import InfiniteScroll from "react-infinite-scroll-component"; // keep this!


const ClientSideOnlyLazy = React.lazy(() =>
  //import LoadMore from '../components/load-more'
  import('../components/load-more')
)



export const query = graphql`
  query ArticleQuery($pageId: ID!) {
    strapi { page( id: $pageId ) {
      id
      title
      title_short
      excerpt
      page_type{
        name
      }
      slug
      site_section{
        section
        slug
      }
      main_image {
        url
        caption
        alternativeText
        imageFile{
          childImageSharp{
            gatsbyImageData(
              width: 1200,
              aspectRatio: 1.4,
              transformOptions: {cropFocus:ENTROPY})
          }
        }
      }
      authors {
        id
        name
        slug
        entity_type {
          slug_prefix
          name
        }
      }
      body_introduction
      body {
        __typename
        ... on STRAPI_ComponentContentBikeMap {
          id
        }
        ... on STRAPI_ComponentContentListTopN {
          id
          description
          page {
            slug
            title
            page_type {
              name
              slug_prefix
            }
            parent {
              slug
            }
            site_section {
              slug
            }
          }
        }
        ... on STRAPI_ComponentContentEmbeddedHtml {
          id
          raw_html
        }
        ... on STRAPI_ComponentMediaImage {
          id
        }
        ... on STRAPI_ComponentContentQuestionAndAnswer {
          id
        }
        ... on STRAPI_ComponentContentText {
          id
        }
      }
      body_conclusion
      authorities {
        id
        name
        slug
        entity_type {
          slug_prefix
          name
        }
      }
      primary_topic
      parent: parent {
        title
        slug
      }
      page_type {
        name
        slug_prefix
      }
      children {
        id
        canonical_url
        slug
        page_type {
          name
          slug_prefix
        }
        site_section: page_type{
          name
          slug_prefix
        }
        title
        excerpt
        page_value
        updated_at
        parent {
          title
          title_short
          slug
        }
        main_image {
          url
          caption
          alternativeText
          imageFile{
            childImageSharp{
              gatsbyImageData(
                width: 300,
                aspectRatio: 1,
                transformOptions: {cropFocus:ENTROPY})
            }
          }
        }
      }
      next_pages {
        id
        canonical_url
        slug
        page_type {
          name
          slug_prefix
        }
      }
      related_pages {
        id
        title
        slug
        page_type {
          name
          slug_prefix
        }
        main_image {
          url
          caption
          alternativeText
          imageFile{
            childImageSharp{
              gatsbyImageData(
                width: 200,
                aspectRatio: 1,
                transformOptions: {cropFocus:ENTROPY})
            }
          }
        }
      }
    }}
  }
`;




const Page = ( {location, data} ) => {
  const article = data.strapi.page;

  const isSSR = typeof window === "undefined"
  
  //    <LoadMore nextArticles={article.next_pages} location={location}/>
  
  const nextPages = article.next_pages
  const currentPage = location

  return (
    <Layout>
      <SEO
        title = {article.title}
      />
      <BlogPost article={article}/>
      {!isSSR && (
        <React.Suspense fallback={<div />}>
          <ClientSideOnlyLazy/>
        </React.Suspense>
      )}
    </Layout>
  );
};

export default Page;
